export interface MaintenanceState {
  enabled: boolean;
  dateTime?: string;
}

export interface MaintenanceConfigResponse {
  enabled: boolean;
  dateTime?: string;
}

/** Default state when config cannot be loaded */
export const DEFAULT_MAINTENANCE_STATE: MaintenanceState = {
  enabled: false,
  dateTime: undefined,
};
